module.exports = __webpack_public_path__ + "static/img/bg_consult_null@2x.20009cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_consult_null@2x.png
// module id = Tw1b
// module chunks = 1